import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const applyAuth = (payload) => {
    if (payload?.session_token) localStorage.setItem("xealth-token", payload.session_token);
    if (payload?.user) setUser(payload.user);
    return payload?.user;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    return applyAuth(data);
  };

  const register = async (name, email, password, inviteCode, acceptGuidelines) => {
    const { data } = await api.post("/auth/register", { name, email, password, invite_code: inviteCode, accept_guidelines: acceptGuidelines });
    return applyAuth(data);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("xealth-token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, logout, refresh, applyAuth }}>
      {children}
    </AuthContext.Provider>
  );
}
